import { Draggable, Droppable } from '@hello-pangea/dnd';
import {
  transportationKeys,
  transportationLabels
} from '../../../../../../../../consts/conditions';

import ConditionBody from '../../ConditionBody';
import ConditionalInput from '../../ConditionalInput';
import classNames from 'classnames';
import ConditionBtnWithLine from '../../ConditionBtnWithLine';
import AddFilterBtn from '../../AddFilterBtn';
import FilterColumnCard from '../../FilterColumnCard';
import ReplaceIcon from '../../../../../../../../assets/icons/replace.svg?react';
import TrashIcon from '../../../../../../../../assets/icons/trash.svg?react';
import Button from '../../../../../../../../components/Button';
import { ShiftingPeriodSection } from './ShiftingPeriodSection';

export const DateShifting = ({
  isChildrenGroup,
  cuurentItem,
  filterTypes,
  onChangeOperator,
  onChangeThenInputType,
  onChangeThen,
  onSelectItem,
  onSelectCondition,
  parentFilterTypeId,
  addCondition,
  selectedItems,
  onDeleteSelectedItems,
  onChangeFunction,
  onChangeInputType,
  onChangeInput,
  onChangeColumn,
  columns,

  onChangeShiftingMethod,
  onChangePeriodAmount,
  onChangeTimePeriod,
  onChangeColumnName
}) => {
  const removeNotAllowed = filterTypes?.[0]?.conditions?.length === 1;

  return (
    <>
      <div id="grid-table-date-shifting-root" className="condition-box">
        <div id="grid-table-date-shifting-list" className="filter-types">
          <Droppable droppableId={cuurentItem?.id} key={cuurentItem?.id}>
            {provided =>
              filterTypes
                .filter(item => item.conditions?.length > 0)
                .map((item, idx) => {
                  const filterTypeId = parentFilterTypeId || item.id;

                  return (
                    <div
                      key={item.id}
                      {...provided.droppableProps}
                      style={{ width: '100%' }}
                      ref={provided.innerRef}
                    >
                      {!isChildrenGroup && idx === 0 && filterTypes?.length > 0 && (
                        <div id="grid-table-date-shifting-header" className="header">
                          <p id="grid-table-date-shifting-label" className="label">
                            {transportationLabels[item.label]}
                          </p>

                          <div className="actions">
                            <Button
                              id="grid-table-date-shifting-delete"
                              size="xs"
                              disabled={!selectedItems?.length > 0 || removeNotAllowed}
                              onClick={() => onDeleteSelectedItems(filterTypeId)}
                            >
                              <TrashIcon
                                style={{
                                  transform: 'scale(1.2)',
                                  marginRight: '5px'
                                }}
                              />
                              Delete
                            </Button>
                          </div>
                        </div>
                      )}
                      <div
                        className={classNames('filter_card', {
                          ['isChildren']: isChildrenGroup,
                          ['noBorderTop']: !isChildrenGroup && idx > 0,
                          ['noBorderBottom']: true,
                          ['isFilter']: true
                        })}
                      >
                        <div id={`grid-table-date-shifting-item-${idx}`} className="filter_content">
                          <ConditionBtnWithLine
                            id={`grid-table-date-shifting-condition-${item.id}`}
                            label={item.conditionLabel}
                            onSelectCondition={val => onSelectCondition(filterTypeId, val, item.id)}
                          />

                          {item?.conditions?.map((value, idx) => {
                            if (value?.conditions?.length > 0)
                              return (
                                <Draggable key={value.id} draggableId={value.id} index={idx}>
                                  {(dragProvided, dragSnapshot) => {
                                    return (
                                      <div
                                        key={value.id}
                                        className="group-wrapper"
                                        ref={dragProvided.innerRef}
                                        {...dragProvided.draggableProps}
                                        style={{
                                          ...dragProvided.draggableProps.style,
                                          width: '100%',
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: '10px',
                                          opacity: dragSnapshot.isDragging ? 0.5 : 1
                                        }}
                                      >
                                        <div
                                          id={`grid-table-date-shifting-group-checkbox-${value.id}`}
                                          className="checkbox_line"
                                        >
                                          <input
                                            id={`grid-table-date-shifting-group-checkbox-input-${value.id}`}
                                            type="checkbox"
                                            className="checkbox"
                                            checked={selectedItems.includes(value.id)}
                                            onClick={() => onSelectItem(value.id)}
                                          />
                                        </div>

                                        <ConditionBody
                                          cuurentItem={value}
                                          filterTypes={[value]}
                                          selectedItems={selectedItems}
                                          onSelectItem={onSelectItem}
                                          addCondition={addCondition}
                                          isChildrenGroup={true}
                                          columns={columns}
                                          parentFilterTypeId={
                                            !isChildrenGroup ? filterTypeId : parentFilterTypeId
                                          }
                                          onChangeInput={onChangeInput}
                                          onChangeColumn={onChangeColumn}
                                          onChangeFunction={onChangeFunction}
                                          onChangeOperator={onChangeOperator}
                                          onChangeInputType={onChangeInputType}
                                          onSelectCondition={onSelectCondition}
                                        />

                                        <div
                                          id={`grid-table-date-shifting-group-replace-${value.id}`}
                                          className="replace-btn"
                                          {...dragProvided.dragHandleProps}
                                        >
                                          <ReplaceIcon />
                                        </div>
                                      </div>
                                    );
                                  }}
                                </Draggable>
                              );

                            return (
                              <Draggable key={value.id} draggableId={value.id} index={idx}>
                                {(dragProvided, dragSnapshot) => (
                                  <div
                                    id={`grid-table-date-shifting-row-${value.id}`}
                                    key={value.id}
                                    ref={dragProvided.innerRef}
                                    {...dragProvided.draggableProps}
                                    style={{
                                      ...dragProvided.draggableProps.style,
                                      opacity: dragSnapshot.isDragging ? 0.5 : 1
                                    }}
                                  >
                                    <FilterColumnCard
                                      id={`grid-table-date-shifting-card-${value.id}`}
                                      key={value.id}
                                      operator={value.operator}
                                      column={value.column}
                                      func={value.function}
                                      value={value.value}
                                      inputType={value.inputType}
                                      columns={columns}
                                      errors={value.errors}
                                      dragHandleProps={{
                                        ...dragProvided.dragHandleProps
                                      }}
                                      hideFunction={true}
                                      isSelected={selectedItems.includes(value.id)}
                                      onSelect={() => onSelectItem(value.id)}
                                      onChangeFunction={val =>
                                        onChangeFunction(filterTypeId, value.id, val)
                                      }
                                      onChangeInputType={val =>
                                        onChangeInputType(filterTypeId, value.id, val)
                                      }
                                      onChangeColumn={val =>
                                        onChangeColumn(filterTypeId, value.id, val)
                                      }
                                      onChangeOperator={val =>
                                        onChangeOperator(filterTypeId, value.id, val)
                                      }
                                      onChangeInput={val =>
                                        onChangeInput(filterTypeId, value.id, val)
                                      }
                                    />
                                  </div>
                                )}
                              </Draggable>
                            );
                          })}

                          {provided.placeholder}

                          <AddFilterBtn
                            id={`grid-table-date-shifting-add-${item.id}`}
                            onClick={type =>
                              addCondition(item.id, type, parentFilterTypeId || filterTypeId)
                            }
                          />
                        </div>

                        {!isChildrenGroup &&
                          (cuurentItem || item).label === transportationKeys.REPLACE && (
                            <div id="grid-table-date-shifting-then" className="then">
                              <p
                                id="grid-table-date-shifting-then-label"
                                style={{ marginTop: '17px' }}
                              >
                                Then
                              </p>
                              <ConditionalInput
                                id="grid-table-date-shifting-then-input"
                                hideFunction={true}
                                hideVariants={['ai_input']}
                                columns={columns}
                                value={item?.then[item?.thenInputType]}
                                type={item?.thenInputType}
                                onChangeType={val =>
                                  onChangeThenInputType(filterTypeId, item.id, val)
                                }
                                onChangeValue={val => onChangeThen(filterTypeId, item.id, val)}
                              />
                            </div>
                          )}
                      </div>
                    </div>
                  );
                })
            }
          </Droppable>
        </div>
      </div>

      <ShiftingPeriodSection
        idPrefix="grid-table-date-shifting-period"
        columns={columns}
        column={cuurentItem?.columnName}
        shiftingMethod={cuurentItem?.shiftingMethod}
        timePeriod={cuurentItem?.timePeriod}
        periodAmount={cuurentItem?.periodAmount}
        onChangeColumn={val => onChangeColumnName(cuurentItem?.id, cuurentItem?.id, val)}
        onChangeShiftingMethod={val =>
          onChangeShiftingMethod(cuurentItem?.id, cuurentItem?.id, val)
        }
        errors={cuurentItem?.errors}
        onChangePeriodAmount={val => onChangePeriodAmount(cuurentItem?.id, cuurentItem?.id, val)}
        onChangeTimePeriod={val => onChangeTimePeriod(cuurentItem?.id, cuurentItem?.id, val)}
      />
    </>
  );
};
